function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import ShortFooter from "components/core/short-footer/short-footer";
import FooterCategoryComponent from "segments/desktop/core-components/long-footer/footer-category/footer-category-component";
import { StyledMobileFooterContainer, StyledDesktopFooterContainer, StyledFooter } from "segments/desktop/core-components/long-footer/long-footer.scss";
import { SocialFooterLinks } from "/constants/links";
import FooterBottomBarComponent from "segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component";
import { getFooterComponents } from "/services/localization/localization-service";
import classnames from "classnames";
import DefaultProps from "./default-props";
const SlimFooter = (props)=>{
    const { translate, localeId, abTests, pageClusterConfig, useProductMiniSiteConfig } = props;
    const SLIM_FOOTER = "slim";
    const renderShortFooter = ()=>{
        return /*#__PURE__*/ _jsx(ShortFooter, _object_spread({}, props));
    };
    const renderSlimFooter = ()=>{
        const getFullFooterForLocalized = true;
        const footerComponents = getFooterComponents(localeId, abTests, getFullFooterForLocalized, {
            pageClusterConfig,
            useProductMiniSiteConfig
        });
        const { SlimFooterLinks } = footerComponents;
        return /*#__PURE__*/ _jsxs(StyledFooter, {
            className: classnames("footer-container", "slim-footer"),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ _jsx("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "categories-container",
                            children: SlimFooterLinks.map((column, index)=>/*#__PURE__*/ _jsx("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ _jsx(FooterCategoryComponent, {
                                        type: column.type,
                                        links: column.links,
                                        hasMondayLogoTitle: index === 0
                                    })
                                }))
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(FooterBottomBarComponent, {
                    SocialFooterLinks: SocialFooterLinks,
                    footerType: SLIM_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyledDesktopFooterContainer, {
                className: "footer-desktop-wrapper",
                children: renderSlimFooter()
            }),
            /*#__PURE__*/ _jsx(StyledMobileFooterContainer, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
export default withAbTests(withGenericConfig(SlimFooter));
SlimFooter.defaultProps = DefaultProps;
